import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "search__input input-field input-field--black" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "search__filters"
}
const _hoisted_5 = ["onClick"]

import { useFilterState } from "@/services/filter-state-service";
import { useFilterStore } from "../../stores/filterStore";
import Cross from '../cross/Cross.vue';
import { SEARCH_PLACEHOLDER } from '@/constants';

export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {


const filterStore = useFilterStore();

const { addSearchFilter, removeSearchFilter } = useFilterState();

const addSearchQuery = (query: string) => {
    if (query === '') {
        return;
    }

    addSearchFilter(query);
    clearSearch();
};

const clearSearch = () => {
    filterStore.searchQuery = '';
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("label", {
        for: "search-query",
        class: "sr-only"
      }, "Sök", -1 /* HOISTED */)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filterStore).searchQuery) = $event)),
        id: "search-query",
        placeholder: _unref(SEARCH_PLACEHOLDER),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (addSearchQuery(_unref(filterStore).searchQuery)), ["enter"]))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
        [_vModelText, _unref(filterStore).searchQuery]
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "search__icon icon icon--search",
        "aria-hidden": "true"
      }, null, -1 /* HOISTED */))
    ]),
    (_unref(filterStore).activeSearchFilters.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterStore).activeSearchFilters, (filter, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "filter",
              key: index,
              onClick: ($event: any) => (_unref(removeSearchFilter)(filter))
            }, [
              _createTextVNode(_toDisplayString(filter) + " ", 1 /* TEXT */),
              _createVNode(Cross)
            ], 8 /* PROPS */, _hoisted_5))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})